import React, { useEffect, useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import useRouter from 'utils/useRouter';
import { Page, Header } from 'components';
import ActivityDataTable from './components/ActivityDataTable.js';
import ActionsButton from './components/ActionsButton.js';
import { GetActivities, FullExport, GetElementCreationTemplate, UploadElementCreation, UploadImportExport } from '../../actions/ActivityViewActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const ActivityView = () => {
	const classes = useStyles();
	const { history } = useRouter();

	const dispatch = useDispatch();

	const user = useSelector(state => state.session.user);
	const activities = useSelector(state => state.activityViewReducer.activities);
	const inputFile = useRef(null);
	const [importType, setImportType] = useState();

	const _getActivities = useCallback(() => {
		dispatch(GetActivities());
	}, []);

	useEffect(() => {
		_getActivities();
	}, [_getActivities]);

	const _openActivityDetails = (id) => {
		history.push(`/tracker/activitydetails/${id}`);
	};

	const _fullExport = () => {
		dispatch(FullExport());
	};

	const _fullImport = () => {
		setImportType('fullImport');
		inputFile.current.click();
	};

	const _elementCreationTemplate = () => {
		dispatch(GetElementCreationTemplate('Files/Templates/Tracker/ElementCreationTemplate.xlsx'));
	};

	const _importCreationTemplate = () => {
		setImportType('importCreationTemplate');
		inputFile.current.click();
	};

	const _onChangeInput = (event) => {
		const { id } = user;
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			if (importType === 'importCreationTemplate') {
				dispatch(UploadElementCreation(id, file));
			} else {
				dispatch(UploadImportExport(id, file));
			}
		}
		// eslint-disable-next-line no-param-reassign
		event.target.value = null;
	};

	return (
		<Page className={classes.root} title="Tracker">
			<Header
				module="Tracker"
				view="Activity Level"
				actions={(
					<ActionsButton
						fullExport={_fullExport}
						fullImport={_fullImport}
						elementCreationTemplate={_elementCreationTemplate}
						importCreationTemplate={_importCreationTemplate}
					/>
				)}
			/>
			<Grid className={classes.container} spacing={3}>
				<Grid item lg={12} xs={12}>
					<ActivityDataTable data={activities} openActivityDetails={_openActivityDetails} />
				</Grid>
			</Grid>
			{/* {openAddEditUserDialog && <AddEditUsersDialog
				onClose={_addEditUserClose}
				open={openAddEditUserDialog}
				user={user}
			/>} */}
			<input
				id="file"
				type="file"
				accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				ref={ref => { inputFile.current = ref; }}
				onChange={_onChangeInput}
				style={{ display: 'none' }}
			/>
		</Page>

	);
};

export default ActivityView;
